import { render, staticRenderFns } from "./PopupGuide.vue?vue&type=template&id=a2465db8&"
import script from "./PopupGuide.vue?vue&type=script&lang=js&"
export * from "./PopupGuide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports